// Lightweight SVG sparkline, no deps
export default function Sparkline({ data = [], height = 56, color = "#E8B84B", fillColor = "rgba(232,184,75,0.18)" }) {
  if (!data.length) return null;
  const W = 320;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const pts = data.map((v, i) => ({
    x: (i / (data.length - 1)) * W,
    y: height - ((v - min) / range) * (height - 14) - 7,
  }));
  const line = pts.map((p) => `${p.x},${p.y}`).join(" ");
  const area = `0,${height} ${line} ${W},${height}`;
  const gid = `spark-grad-${color.replace(/[^a-z0-9]/gi, "")}`;

  return (
    <svg width="100%" height={height} viewBox={`0 0 ${W} ${height}`} preserveAspectRatio="none">
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.32" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polygon points={area} fill={`url(#${gid})`} />
      <polyline
        points={line}
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {pts.map((p, i) => (
        <circle
          key={i}
          cx={p.x}
          cy={p.y}
          r={i === pts.length - 1 ? 3.5 : 0}
          fill={color}
        />
      ))}
    </svg>
  );
}
